import { FormControl, RadioGroup, FormControlLabel, Radio, FormHelperText, Typography } from '@mui/material';
import React from 'react';
import { useFormState, useFormContext, useController } from 'react-hook-form';

// TODO: Typa
const ControlledRadioButton = (props) => {
  const { setValue } = useFormContext();
  const { isDirty, errors } = useFormState();

  const { items, helperText, label, value, name, required, row = true, ...rest } = props; // disabled & id not used

  const { field } = useController({
    name,
  });

  let isError = false;
  let errorMessage = '';
  if (errors && Object.prototype.hasOwnProperty.call(errors, name)) {
    isError = true;
    errorMessage = errors[name]?.message?.toString() || '';
  }

  const [, setInternalValue] = React.useState(value || '');

  return (
    <FormControl component='fieldset' error={isError} required={required}>
      <Typography variant='caption' gutterBottom sx={{ lineHeight: 1, color: 'rgba(0, 0, 0, 0.6)' }}>
        {label} {required ? '*' : null}
      </Typography>
      <RadioGroup {...rest} {...field} row={row}>
        {items.map((c) => (
          <FormControlLabel
            control={
              <Radio
                required={required}
                color='primary'
                value={c.value}
                checked={c.value === field.value}
                onChange={(e) => {
                  setInternalValue(e.target.value);
                  setValue(name, e.target.value);
                }}
              />
            }
            key={c.value}
            label={c.label}
          />
        ))}
      </RadioGroup>
      {isDirty && isError && (
        <FormHelperText>
          <span>{errorMessage}</span>
        </FormHelperText>
      )}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default ControlledRadioButton;
